import { TOGGLE_SEARCH } from './../const';

export default (toggle) => {
    return {type: TOGGLE_SEARCH, toggle}
}
